console.log("loading");
async function initMap() {
    // Create the map.
    const { Map, InfoWindow } = await google.maps.importLibrary("maps");
    const { Autocomplete } = await google.maps.importLibrary("places");
    const { Marker } = await google.maps.importLibrary("marker");
    const { Size } = await google.maps.importLibrary("core");

    var map = new Map(document.getElementById('mapApp'), {
      zoom: 5,
      center: {lat: 39, lng: -95},
    });

    // Load the stores GeoJSON onto the map.
    map.data.loadGeoJson("https://cdn.shopify.com/s/files/1/0756/4987/files/walmartStores.json?v=1692309767", {idPropertyName: 'storeid'});
  
    var infoWindow = new InfoWindow();

    map.data.setStyle((feature) => {
        return {
          icon: {
            url: `https://cdn.shopify.com/s/files/1/0756/4987/files/ZW-Map-PointerFlag-B.png?v=1692215349`,
            scaledSize: new Size(32, 32),
          },
        };
      });
    
    // Show the information for a store when its marker is clicked.
    map.data.addListener('click', (event) => {
      var category = event.feature.getProperty('category');
      var name = event.feature.getProperty('name');
      var description = event.feature.getProperty('description');
      var hours = event.feature.getProperty('hours');
      var phone = event.feature.getProperty('phone');
      var position = event.feature.getGeometry().get();
      var products = event.feature.getProperty('products');
      var link = event.feature.getProperty('link');
      var content = `
      <div>
        <h3 style="text-align:center;" >${name}</h3><p>${description}</p>
        <p><b>Open:</b> ${hours}<br/><b>Phone:</b> ${phone}<br/><b>Products:</b></p>
      	<a style="color:#00abc7;" href=${link[1]} >Go to google maps </a>
      	<div style="display:flex; flex-direction: row;width: 100%;" >
      		<div style="width: 50%; display: flex; flex-direction: column; align-items: center;">
      			<img style="height: 120px; margin-top:10px;" src="https://cdn.shopify.com/s/files/1/0756/4987/files/DE_45.jpg?v=1692309797">
      			<p style="text-align:center;">${products[0]}</p>
      		</div>
      		<div style="width: 50%; display: flex; flex-direction: column; align-items: center;" >
      			<img style="height: 120px;" src="https://cdn.shopify.com/s/files/1/0756/4987/files/NB_60.jpg?v=1692309797" >
      			<p style="text-align:center;">${products[1]}</p>
      		</div>
      	</div>
      </div>
      `;      
  
      infoWindow.setContent(content);
      infoWindow.setPosition(position);
      infoWindow.setOptions({pixelOffset: new Size(0, -30)});
      infoWindow.open(map);
      
    });

    // Build and add the search bar
    var card = document.createElement('div');
    var titleBar = document.createElement('div');
    var title = document.createElement('div');
    var container = document.createElement('div');
    var input = document.createElement('input');
    var options = {
        types: ['address'],
        componentRestrictions: {country: 'us'},
    };

    card.setAttribute('id', 'pac-card');
    title.setAttribute('id', 'pac-title');
    title.textContent = 'Find the nearest store';
    titleBar.appendChild(title);
    container.setAttribute('id', 'pac-container');
    input.setAttribute('id', 'pac-input');
    input.setAttribute('type', 'text');
    input.setAttribute('placeholder', 'Enter an address');
    container.appendChild(input);
    card.appendChild(titleBar);
    card.appendChild(container);
    map.controls[google.maps.ControlPosition.TOP_RIGHT].push(card);

    // Make the search bar into a Places Autocomplete search bar and select
    // which detail fields should be returned about the place that
    // the user selects from the suggestions.
    var autocomplete = new Autocomplete(input, options);

    autocomplete.setFields(
      ['address_components', 'geometry', 'name']);

    // Set the origin point when the user selects an address
    var originMarker = new Marker({map: map});
    originMarker.setVisible(false);
    let originLocation = map.getCenter();

    autocomplete.addListener('place_changed', async () => {
        originMarker.setVisible(false);
        originLocation = map.getCenter();
        var place = autocomplete.getPlace();

        if (!place.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        window.alert('No address available for input: \'' + place.name + '\'');
        return;
        }

        // Recenter the map to the selected address
        originLocation = place.geometry.location;
        map.setCenter(originLocation);
        map.setZoom(9);
       // console.log(place);

        originMarker.setPosition(originLocation);
        originMarker.setVisible(true);

        // Use the selected address as the origin to calculate distances
        // to each of the store locations
        //console.log(map.data, originLocation);
        //var rankedStores = await calculateDistances(map.data, originLocation);
        
        //showStoresList(map.data, rankedStores);

        return;
    });
}

async function calculateDistances(data, origin) {
  var stores = [];
  var destinations = [];
  console.log("start calculation");
  // Build parallel arrays for the store IDs and destinations
  data.forEach((store) => {
    var storeNum = store.getProperty('storeid');
    var storeLoc = store.getGeometry().get();

    stores.push(storeNum);
    destinations.push(storeLoc);
  });

  // Retrieve the distances of each store from the origin
  // The returned list will be in the same order as the destinations list
  console.log("retrieving");
  var service = new google.maps.DistanceMatrixService();
  var getDistanceMatrix =
    (service, parameters) => new Promise((resolve, reject) => {
      service.getDistanceMatrix(parameters, (response, status) => {
          console.log("status", status, response);
        if (status != google.maps.DistanceMatrixStatus.OK) {
          console.log("rejected", response);
          reject(response);
        } else {
          var distances = [];
          var results = response.rows[0].elements;
          for (let j = 0; j < results.length; j++) {
            var element = results[j];
            var distanceText = element.distance.text;
            var distanceVal = element.distance.value;
            var distanceObject = {
              storeid: stores[j],
              distanceText: distanceText,
              distanceVal: distanceVal,
            };
            distances.push(distanceObject);
          }
          console.log("resolved");
          resolve(distances);
        }
      });
    });

  var distancesList = await getDistanceMatrix(service, {
    origins: [origin],
    destinations: destinations,
    travelMode: 'DRIVING',
    unitSystem: google.maps.UnitSystem.METRIC,
  });

  distancesList.sort((first, second) => {
    return first.distanceVal - second.distanceVal;
  });
  console.log("distancelist", distancesList);
  return distancesList;
}

function showStoresList(data, stores) {
  if (stores.length == 0) {
    console.log('empty stores');
    return;
  }

  let panel = document.createElement('div');
  // If the panel already exists, use it. Else, create it and add to the page.
  if (document.getElementById('pac-panel')) {
    panel = document.getElementById('pac-panel');
    // If panel is already open, close it
    if (panel.classList.contains('pac-open')) {
      panel.classList.remove('pac-open');
    }
  } else {
    panel.setAttribute('id', 'pac-panel');
    var body = document.body;
    body.insertBefore(panel, body.childNodes[0]);
  }

  // Clear the previous details
  while (panel.lastChild) {
    panel.removeChild(panel.lastChild);
  }

  stores.forEach((store) => {
    // Add store details with text formatting
    var name = document.createElement('p');
    name.classList.add('pac-place');
    var currentStore = data.getFeatureById(store.storeid);
    name.textContent = currentStore.getProperty('name');
    panel.appendChild(name);
    var distanceText = document.createElement('p');
    distanceText.classList.add('distanceText');
    distanceText.textContent = store.distanceText;
    panel.appendChild(distanceText);
  });

  // Open the panel
  panel.classList.add('pac-open');

  return;
}

initMap();